<template>
  <Layout>
    <PageHeader :items="items" :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Table -->
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      :options="pageOptions"
                      class="form-select form-select-sm"
                      size="sm"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      class="form-control form-control-sm ms-2"
                      placeholder="Search..."
                      type="search"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :current-page="currentPage"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="filterOn"
                :items="this.Turnaround"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                bordered
                class="datatables"
                responsive="sm"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(action)="data">
                  <button
                    v-b-modal.modal-lg
                    class="btn btn-info btn-sm"
                    @click="View_Services(data)"
                  >
                    <i class="fa fa-eye"></i> View
                  </button>
                </template>
              </b-table>
              <h3 v-if="!this.Turnaround" class="text-primary text-center">
                <b-spinner class="m-0" role="status" variant="primary"></b-spinner>
                Please wait...
              </h3>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-lg"
      size="lg"
      :title="'SERVICES FOR ' + patient.toUpperCase()"
      title-class="font-18"
      hide-footer
    >
      <div class="table-responsive">
        <table class="table table-bordered border-primary mb-0">
          <thead>
            <tr>
              <th>S/N</th>
              <th>SERVICE</th>
              <th>TIME INTERVAL</th>
              <th>TURN AROUND TIME</th>
              <th>SERVICE STATUS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(serv, index) in existingServices" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ serv.service ? serv.service : "" }}</td>
              <td>{{ serv.interval ? serv.interval : "--" }}</td>
              <td>{{ serv.time ? serv.time : "--" }}</td>
              <td>{{ serv.status ? serv.status : "--" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { mapGetters, mapActions } from "vuex";

export default {
  page: {
    title: "Turn around time Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      title: "CLIENT'S TURN AROUND TIME",
      items: [
        {
          text: "Audits",
          href: "#",
        },
        {
          text: "Turn around time",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 250, 500, 1000],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "branch",
          sortable: true,
          label: "BRANCH",
        },
        {
          key: "date",
          sortable: true,
          label: "VISIT DATE",
        },
        {
          key: "client",
          sortable: true,
          label: "PATIENT",
        },
        {
          key: "interval",
          sortable: true,
          label: "VISIT TURN AROUND TIME",
        },
        {
          key: "status",
          sortable: true,
          label: "STATUS",
        },
        {
          key: "action",
          sortable: true,
          label: "SERVICE TAT",
        },
      ],
      existingServices: [],
      patient: "",
    };
  },

  computed: {
    ...mapGetters("audits", ["Turnaround"]),

    rows() {
      return this.Turnaround ? this.Turnaround.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Turnaround ? this.Turnaround.length : 1;
  },
  methods: {
    ...mapActions({
      FetchTurnaround: "audits/fetchTurnaround",
    }),

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    View_Services(data) {
      this.existingServices = data.item.services;
      this.patient = data.item.client;
    },
  },

  created() {
    this.FetchTurnaround();
  },
};
</script>

<style lang="css" scoped></style>
